import { useMutation, useQueryClient } from '@tanstack/react-query'
import { login } from '../../../../apis/auth'
import { queryKeys } from '../../../../shared'

/**
 * ログイン Mutation hook
 *
 * email/passwordでログインAPIを呼び出す。
 * 成功時は認証キャッシュを無効化する。
 */
export const useLoginMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) =>
      login(email, password),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.auth.all })
    },
  })
}
